export default {"src":"/_next/static/media/stijldansen.f9ac5321.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};